import { PrintType } from '@/types';
import { ScreenPrint } from '@/model/printType/printTypes';

export function getIsScreenPrintType(printType: PrintType) {
  return printType.id === ScreenPrint;
}
